<template>
  <vs-table id="cartEntryTable" ref="cartEntryTable"
    :data="lossMode && lossTypeSelection ? selectedLossStocks : currentCart ? currentCart.cartEntries : null "
    v-model="selected" class="bg-white w-full tablez">
    <div slot="header" class="w-full flex flex-wrap items-center flex-grow justify-between">
      <order-list ref="orderList" :currentDate="currentDate" :currentTime="currentTime" />
      <loss-reason-select ref="lossReasonSelect" @done="lossMode = false" />
      <cake-question ref="cakeQuestion" @moveOn="moveOnToOrderList" />
      <qr-reader ref="qrReader" @success="commitQrCode" />
      <div id="basket-group"
        v-if="!lossMode && currentCart && (currentCart.cartEntries.length > 0 || carts.length > 1)">
        <vs-button @click="chanceCurrentCart(cart)" :class="{'basket-number-active' : currentCart.id == cart.id}"
          class="basket-number text-primary" color="transparent" v-for="cart in carts" :key="cart.id">
          {{cart.id}}
        </vs-button>
        <vs-button class="basket-plus text-primary" @click="openNewBasket" color="transparent" icon-pack="feather"
          icon="icon-plus">
        </vs-button>
      </div>
      <div id="basket-actions"
        v-show="lossMode || currentCart && (currentCart.cartEntries.length > 0 || carts.length > 1)" class="w-full p-5">
        <vs-row vs-type="flex" vs-w="12" style="height:100%;">
          <vs-col vs-type="flex" vs-w="12">
            <vs-row vs-type="flex" vs-w="12">
              <vs-row vs-type="flex" vs-w="12" style="margin-bottom:1vw;" vs-justify="flex-end">
                <vs-col vs-type="flex" vs-w="6" vs-justify="center" vs-align="center" v-show="!lossMode">
                  <p class="label">İndirim :</p>
                  <p class="ml-2 price text-primary">00.00 ₺</p>
                </vs-col>
                <vs-col vs-type="flex" vs-w="6" vs-justify="center" vs-align="center"
                  v-if="!lossMode || (lossMode && !lossTypeSelection)">
                  <p class="label">Toplam :</p>
                  <p class="ml-2 price text-primary">{{$toCurrency(currentCart.totalPrice)}}</p>
                </vs-col>
              </vs-row>
              <vs-row vs-type="flex" vs-w="12" vs-justify="space-between">
                <vs-col vs-type="flex" vs-w="2.5" vs-justify="center">
                  <vs-row vs-type="flex" vs-w="12" vs-justify="center">
                    <vs-button class="flex vx-col sm:w-full md:w-1/2 lg:1/2 xl:1/4 p-0 justify-center"
                      color="transparent" style="align-items:center;">
                      <vs-row vs-type="flex" vs-w="12" vs-justify="center">
                        <vs-button icon-pack="feather" icon="icon-x" class="basket-action bg-danger text-white"
                          color="transparent"
                          @click="!lossMode || (lossMode && !lossTypeSelection) ? ClearCart() : clearLossList()">
                        </vs-button>
                      </vs-row>
                      <vs-row vs-type="flex" vs-w="12" vs-justify="center" class="mt-4">
                        <p class="sub-layer">Temizle</p>
                      </vs-row>
                    </vs-button>
                  </vs-row>
                </vs-col>
                <vs-col v-if="!lossMode" vs-type="flex" vs-w="3" vs-justify="center">
                  <vs-row vs-type="flex" vs-w="12" vs-justify="center">
                    <vs-button v-if="!currentCart.customer"
                      class="flex vx-col w-full p-0 justify-center" color="transparent"
                      style="align-items:center;">
                      <vs-row vs-type="flex" vs-w="12" vs-justify="center">
                        <vs-button icon-pack="feather" icon="icon-command" class="basket-action bg-navy text-white"
                          color="transparent" @click="openQrReader">
                        </vs-button>
                      </vs-row>
                      <vs-row vs-type="flex" vs-w="12" vs-justify="center" class="mt-4">
                        <p class="sub-layer">Qr Kod</p>
                      </vs-row>
                    </vs-button>
                    <vs-button v-else class="flex vx-col w-full p-0 justify-center"
                      color="transparent" style="align-items:center;">
                      <vs-row vs-type="flex" vs-w="12" vs-justify="center">
                        <vs-button icon-pack="feather" icon="icon-command" class="basket-action bg-warning text-white"
                          color="transparent" @click="clearQr">
                        </vs-button>
                      </vs-row>
                      <vs-row vs-type="flex" vs-w="12" vs-justify="center" class="mt-4">
                        <p class="sub-layer">QR Temizle</p>
                      </vs-row>
                    </vs-button>
                  </vs-row>
                </vs-col>
                <vs-col vs-type="flex" vs-w="5.75">
                  <vs-row vs-type="flex" vs-w="12" vs-justify="center">
                    <vs-button type="gradient"
                      :disabled="lossMode && lossTypeSelection ? (selectedLossStocks.length == 0) : currentCart.cartEntries.length==0"
                      size="large" color="primary" id="order-done"
                      @click="!lossMode || (lossMode && !lossTypeSelection) ? PlaceOrder() : submitLoss()">
                      {{!lossMode ? 'Siparişi Tamamla !' : 'Zayiat Oluştur' }}
                    </vs-button>
                  </vs-row>
                </vs-col>
              </vs-row>
            </vs-row>
          </vs-col>
        </vs-row>
      </div>
      <vs-row vs-type="flex" vs-w="12" vs-justify="space-between" vs-align="center"
        class="px-5 py-2 bg-primary2 border-radius">

        <vs-col vs-type="flex" vs-w="4">
          <span class="text-small text-white weight-500">{{currentDate}}</span>
        </vs-col>

        <vs-col v-show="!lossMode && currentCart && (currentCart.cartEntries.length > 0 || carts.length > 1)"
          vs-type="flex" vs-w="4" vs-justify="center" vs-align="center">
          <span class="text-small bold text-white">Sepet {{currentCart.id}}</span>
        </vs-col>

        <vs-col v-show="lossMode" vs-type="flex" vs-w="4" vs-justify="center" vs-align="center">
          <span class="text-small bold text-white">Zayiatlar</span>
        </vs-col>

        <vs-col vs-type="flex" vs-w="4" vs-justify="flex-end">
          <span class="text-white text-small weight-500">{{currentTime}}</span>
        </vs-col>
      </vs-row>
      <vs-row vs-type="block" vs-w="10" vs-justify="center" vs-align="center"
        class="border-white pointer text-center m-auto">
        <transition v-if="currentCart.customer" name="fade">
          <vx-tooltip :text="'#' + currentCart.customer.qrCode " position="top">
            <vs-button size="small" color="transparent"
              class="text-white text-small weight-600 bg-navy italic m-auto mt-1" icon-pack="feather"
              icon="icon-user-check">
              {{currentCart.customer.name ? currentCart.customer.name : currentCart.customer.userName + "..."}}
            </vs-button>
          </vx-tooltip>
        </transition>
      </vs-row>
    </div>

    <template slot="thead" class="w-full"
      v-if="(!lossMode && currentCart && currentCart.cartEntries.length > 0) || (lossMode && !lossTypeSelection)">

      <vs-th class="w-6/12 border-bottom">
        <p class="text-primary text-small bold">Ürün</p>
      </vs-th>
      <vs-th class="w-1/12 border-bottom">
        <p class="text-primary text-small bold">Adet</p>
      </vs-th>
      <vs-th class="w-4/12 border-bottom">
        <p class="text-primary text-small bold">Fiyat(₺)</p>
      </vs-th>
    </template>

    <template slot="thead" class="w-full" v-if="(lossMode && lossTypeSelection)">

      <vs-th class="w-6/12">
        <p class="h5 text-primary">Hammadde</p>
      </vs-th>
      <vs-th class="w-1/12">
        <p class="h5 text-primary">Birim</p>
      </vs-th>
      <vs-th class="w-4/12">
        <p class="h5 text-primary">Miktar</p>
      </vs-th>
    </template>

    <template slot-scope="{data}" style="background-color:red;">
      <tbody
        v-if="(currentCart && (currentCart.cartEntries.length > 0 || carts.length > 1) && !lossMode) || (lossMode && !lossTypeSelection)">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" class="align-center">
          <vs-td class="w-6/12">
            <p class="weight-600 truncate text-primary">{{ data[indextr].productName }}</p>
            <span v-for="(extra,eindex) in tr.extras" :key="'extra'+eindex">
              <p class="product-extra text-primary" v-if="extra.quantity > 0 && (extra.variants.length == 0)">
                x{{extra.quantity}} | {{extra.name}}
              </p>
              <span style="display:block;" class="product-extra text-primary" v-else-if="(extra.variants.length > 0)"
                v-for="seletedVariantExtra in returnSelectedExtraVariant(extra)" :key="seletedVariantExtra">
                {{seletedVariantExtra}}
              </span>
            </span>
            <span v-for="(step,rindex) in tr.recipe.steps" :key="'step'+rindex">
              <p class="product-extra text-primary"
                v-if="step.originRawMaterialId != null && (step.selected != null && step.selected) && !step.isRemoved">
                {{step.name}}
              </p>
            </span>
          </vs-td>
          <vs-td class="w-1/12">
            <p class="weight-600">{{ data[indextr].quantity }}</p>
          </vs-td>
          <vs-td class="w-4/12">
            <p class="weight-600">{{ $toCurrency(data[indextr].price) }}</p>
          </vs-td>
        </vs-tr>
      </tbody>
      <tbody v-if="lossMode && lossTypeSelection">
        <vs-tr :data="tr" :key="tr.id" v-for="tr in data" class="align-center">
          <vs-td class="w-6/12">
            <p class="weight-600 truncate text-primary">{{ tr.name }}</p>
          </vs-td>
          <vs-td class="w-1/12">
            <p class="weight-600">{{ tr.unit.name }}</p>
          </vs-td>
          <vs-td class="w-4/12">
            <p class="weight-600">{{ tr.quantity}}</p>
          </vs-td>
        </vs-tr>
      </tbody>
      <div id="empty-basket"
        v-if="!lossMode && currentCart && (currentCart.cartEntries.length == 0 && carts.length == 1) ">
        <vs-row vs-type="flex" vs-w="12">
          <vs-col vs-type="flex" vs-w="12" vs-justify="center" vs-align="center">
            <vs-row vs-type="flex" vs-w="12">
              <vs-row vs-type="flex" vs-w="12">
                <vs-col vs-type="flex" vs-w="12" vs-justify="center" class="w-auto m-auto">
                  <img src="@/assets/general/cash-register.svg" class="w-full img-border">
                </vs-col>
              </vs-row>
              <vs-row vs-type="flex" vs-w="12" class="mt-5 justify-center">
                <vs-col vs-type="flex" vs-w="9" vs-justify="center">
                  <vs-row vs-type="flex" vs-w="12">
                    <vs-row vs-type="flex" vs-w="12" vs-justify="center">
                      <p class="h5 bold align-center text-primary">Açık Sepet Bulunmamaktadır.</p>
                    </vs-row>
                    <vs-row vs-type="flex" vs-w="12" vs-justify="center">
                      <p class="text-primary align-center h5 mt-3">Satışa Başlamak İçin Sipariş Giriniz.</p>
                    </vs-row>
                  </vs-row>
                </vs-col>
              </vs-row>
            </vs-row>
          </vs-col>
        </vs-row>
      </div>
    </template>
  </vs-table>

</template>

<script>
  import QrReader from "./QrReader.vue";
  import LossReasonSelect from "./LossReasonSelect.vue";
  import OrderList from "./OrderList.vue";
  import CakeQuestion from "./CakeQuestion.vue";
  export default {
    data() {
      return {
        baskets: [],
        basketCount: 0,
        selected: "",
        moment: require('moment-timezone'),
        currentTime: "",
        broadcaster: null
      };
    },
    components: {
      OrderList,
      CakeQuestion,
      LossReasonSelect,
      QrReader
    },
    mounted() {
      this.getCurrentTime();
    },
    watch: {
      selected: {
        deep: true,
        handler(val) {
          if (val.id && !this.lossMode) {
            //this.$store.dispatch("selfservice/setToUpdateEntry", null)
            this.$store.dispatch("selfservice/setSelectedProduct", null);
            this.$store.dispatch("selfservice/setPreSelectedProduct", null);
            this.$nextTick(() => {
              this.$store.dispatch("selfservice/setToUpdateEntry", val);
            });
          }
        }
      },
      toUpdateEntry(val) {
        if (!val) this.selected = "";
      },
       // Sepetteki değişiklikleri izle
    'currentCart.cartEntries': {
      deep: true,
      handler(newCartEntries) {
        console.log('handle', newCartEntries);
        if (newCartEntries) {
          // Değişiklikleri yayınla
          this.broadcaster.postMessage({
            type: 'CART_UPDATE',
            data: newCartEntries
          });
        }
      }
    }
    },
    beforeDestroy() {
    // Kanalı temizle
    if (this.broadcaster) {
      this.broadcaster.postMessage({
            type: 'CART_UPDATE',
            data: []
          });
      this.broadcaster.close();
    }
  },
    created() {
      this.broadcaster = new BroadcastChannel('cart-channel');
      console.log(this.currentCart.cartEntries);
      if(this.currentCart.cartEntries){
        this.broadcaster.postMessage({
            type: 'CART_UPDATE',
            data: []
          });
      }

    //   this.broadcaster.onmessage = (event) => {
    //   if (event.data.type === 'CART_UPDATE') {
    //     console.log(event.data.data);
    //   }
    // };
    },
    computed: {
      isCakeQuestioned: {
        get() {
          return this.$store.getters["selfservice/getCakeQuestioned"];
        },
        set(val) {
          this.$store.dispatch("selfservice/setCakeQuestioned", val);
        }
      },
      isOrderListActive() {
        return this.$refs.orderList ? this.$refs.orderList.isActive : false;
      },
      selectedLossStocks() {
        return this.$store.getters["selfservice/getSelectedLossStocks"]
      },
      lossTypeSelection: {
        get() {
          return this.$store.getters["selfservice/getLossType"];
        },
        set(val) {
          this.$store.dispatch("selfservice/setLossType", val);
        }
      },
      lossMode: {
        get() {
          return this.$store.getters["selfservice/getLossMode"];
        },
        set(val) {
          this.$store.dispatch("selfservice/setLossMode", val);
        }
      },
      currentCart: function () {
        return this.$store.getters["selfservice/getCurrentCart"];
      },
      carts: function () {
        return this.$store.getters["selfservice/getCarts"];
      },
      isScreenLock: {
        get() {
          return this.$store.getters["selfservice/getScreenLock"];
        },
        set(val) {
          this.$store.dispatch("selfservice/setScreenLock", val);
        }
      },
      activePersonal: {
        get() {
          return this.$store.getters["selfservice/getActivePersonal"];
        },
        set(val) {
          this.$store.dispatch("selfservice/setActivePersonal");
        }
      },
      toUpdateEntry() {
        return this.$store.getters["selfservice/getToUpdateEntry"];
      },
      currentDate() {
        let date = this.moment().locale("tr");
        date = date.tz("Europe/Istanbul").format("ddd Do MMM")
        return date;
      },
    },
    methods: {
      clearQr() {
        this.$store.dispatch("selfservice/setCurrentCartCustomer", null);
      },
      commitQrCode(customer) {
        this.$store.dispatch("selfservice/setCurrentCartCustomer", customer);
      },
      openQrReader() {
        this.$refs.qrReader.isActive = true;
      },
      submitLoss: function () {
        let obj = {
          stockEntries: this.selectedLossStocks,
          branchId: 0,
          userId: 0,
          type: "Stock"
        };
        this.$refs.lossReasonSelect.isActive = true;
        this.$refs.lossReasonSelect.lossData = obj;
      },
      clearLossList() {
        if (this.selected.id) this.$store.dispatch("selfservice/removeSelectedLossStock", this.selected.id);
        else this.$store.dispatch("selfservice/clearSelectedLossStocks");
        this.selected = "";
      },
      setBillExtras(extras) {
        let returnObj = [];
        extras.forEach(x => {
          if (x.quantity > 0) {
            returnObj.push(x);
          } else if (x.quantity == 0 && x.variants != null && x.variants.length > 0) {
            x.variants.filter(y => y.quantity > 0).forEach(z => {
              returnObj.push(z);
            })
          }
        });
        return returnObj;
      },
      returnSelectedExtraVariant(extra) {
        let returnObj = [];
        let selectedVariants = extra.variants.filter(x => {
          if (x.quantity > 0) {
            returnObj.push("x" + x.quantity + " | " + x.name)
          };
        });
        return returnObj.length > 0 ? returnObj : null;
      },
      moveOnToOrderList() {
        this.$refs.cakeQuestion.isActive = false;
        this.$refs.orderList.isActive = true;
      },
      getCurrentTime() {
        this.currentTime = this.moment().locale("tr");
        this.currentTime = this.currentTime.tz('Europe/Istanbul').format("H:mm:ss");
        setTimeout(this.getCurrentTime, 1000)
      },
      ClearCart: function () {
        if (this.currentCart.cartEntries.length > 0) {
          this.$store.dispatch("selfservice/removeEntryFromCurrentCart", this.selected);
          this.$store.dispatch("selfservice/setToUpdateEntry", null)
        }
        if (this.currentCart.cartEntries.length == 0) {
          this.$store.dispatch("selfservice/removeCart", this.currentCart.id);
          this.isCakeQuestioned = false;
        }
      },
      PlaceOrder: function () {
        console.log(this.currentCart.cartEntries);
        let orderBillEntries = [];
        this.currentCart.cartEntries.forEach(tr => {
          orderBillEntries.push({
            productId: tr.productId,
            childProductId: tr.childProductId,
            productQuantity: tr.quantity,
            productName: tr.productName,
            recipe: tr.recipe,
            variantItems: tr.recipe.steps.filter(x => x.selected == true && x.isDefault == false),
            extras: this.setBillExtras(tr.extras),
            price: (tr.price / tr.quantity) - this.sumOfExtraPrices(tr.extras)
          });
        });
        if (!this.lossMode) {
          this.$refs.orderList.orderBillEntries = orderBillEntries;
          // this.$store.dispatch("selfservice/removeEntryFromCurrentCart", null);
          let navigationQuestion = this.$store.getters["selfservice/getNavigationQuestion"];
          if ((navigationQuestion.categoryId != null || navigationQuestion.productId != null) && !this.isCakeQuestioned && !this.currentCart.cartEntries.some(entry => entry.categories.some(category => category.id == navigationQuestion.categoryId))) {
            this.$refs.cakeQuestion.isActive = true;
          } else {
            this.moveOnToOrderList();
          }
        } else {
          let obj = {
            entries: orderBillEntries,
            branchId: 0,
            userId: 0,
            type: "Product"
          };
          this.$refs.lossReasonSelect.isActive = true;
          this.$refs.lossReasonSelect.lossData = obj;
        }
      },
      sumOfExtraPrices(extras) {
        let sum = 0;
        extras.forEach(x => {
          if (x.variants != null && x.variants.length > 0) {
            x.variants.forEach(y => {
              sum += y.price * y.quantity;
            });
          } else {
            sum += x.price * x.quantity;
          }
        });
        return sum;
      },
      openNewBasket() {
        let id = this.carts.length;
        let newCart = {
          id: id,
          cartEntries: [],
          totalPrice: 0,
          active: true
        };
        this.$store.dispatch("selfservice/createNewCart", newCart);
        this.$store.dispatch("selfservice/setToUpdateEntry", null)
        this.$store.dispatch("selfservice/setCakeQuestioned", false)
      },
      chanceCurrentCart(cart) {
        this.$store.dispatch("selfservice/setCurrentCart", cart);
        this.$store.dispatch("selfservice/setToUpdateEntry", null)
      }
    }
  };

</script>

<style>
  .product-name {
    font-weight: 600 !important;
  }

  .product-extra {
    font-weight: 400;
    font-style: italic;
    font-size: .75rem;
  }

  .sub-layer {
    font-size: 1rem;
    font-weight: 500 !important;
    line-height: 1.5rem;
    color: #0e0e0e;
    letter-spacing: 0.5px;
  }

  .basket-action {
    box-shadow: 1px 6px 4px #00000029;
    color: #804000;
    border-radius: 50%;
    width: 3.5rem !important;
    height: 3.5rem !important;
  }

  .basket-action i {
    font-size: 2rem !important;
    text-shadow: 1px 1px 5px gainsboro;
  }

  #order-done {
    border-radius: 15px;
    padding: 1rem 2rem !important;
    font-size: 1.3rem !important;
    font-weight: bold !important;
    letter-spacing: 0.5px;
  }

  #price-details {
    display: flex;
    flex-direction: column;
  }

  .price {
    font-weight: 600 !important;
    font-style: italic;
    font-size: 1.3vw;
    line-height: 1.1vw;
  }

  .label {
    font-size: 1.3vw;
    font-weight: 500 !important;
    line-height: 1.1vw !important;
  }

  .align-center {
    text-align: center !important;
  }

  .img-border {
    border: 2px solid #000000;
    border-radius: 143px;
    border-color: #804000;
  }

  #empty-basket {
    height: 40vh;
    display: flex;
  }

  #cartEntryTable .con-tablex .vs-con-tbody .vs-table .vs-table--thead tr th .vs-table-text {
    border: none !important;
  }

  #cartEntryTable .con-tablex .vs-con-tbody {
    background-color: white;
    border: none !important;
  }

  #cartEntryTable .con-tablex .vs-con-tbody .vs-table tbody .tr-values {
    border: none !important;
    box-shadow: none !important;
  }


  .tablez {
    position: relative !important;
    box-shadow: 0px 3px 6px #00000029 !important;
  }

  .tablez .vs-table--content {
    height: 43vh;
    width: 42vw;
  }

  #basket-group {
    position: absolute;
    left: -54px;
    top: 0;
    z-index: 10000;
    width: 53px;
  }

  #basket-actions {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 11rem;
    border-top: 0.1rem dotted #000000;
  }

  .basket-number {
    cursor: pointer;
    background-color: #ffffff !important;
    text-shadow: 0px 1px black;
    border-radius: 6px 0px 0px 6px;
    padding: 0 1rem !important;
    width: 42px !important;
    height: 40px !important;
    -webkit-box-shadow: 0 8px 6px -6px black;
    -moz-box-shadow: 0 8px 6px -6px black;
    box-shadow: 0px 8px 6px -6px black;
    margin-bottom: 0.2rem;
    margin-right: 0.1rem;
    float: right !important;
    font-size: 1.2rem !important;
  }

  .basket-number-active {
    background: transparent linear-gradient(180deg, #6A1F13 0%, #9A2411 100%) 0% 0% no-repeat padding-box !important;
    color: #F1F1F1 !important;
  }

  .basket-plus {
    background-color: #ffffff !important;
    box-shadow: -7px 2px 6px #00000029;
    border-radius: 8px 0px 0px 8px;
    border-right: none;
    width: 60px !important;
    height: 30px !important;
    margin-right: -4px;
    float: right !important;
    padding: 0 !important;
  }

  .basket-plus i {
    font-size: 1.2rem !important;
    font-weight: 600 !important;
  }

  .product-name {
    font-weight: 400;
  }

</style>
